import { getDeviceId } from "./device-id";

// API base URL. Empty string in dev → relative paths → Vite proxy handles
// /api/* (see vite.config.ts). A production/staging build bakes in the real
// backend URL via VITE_API_BASE_URL at build time.
export const API_BASE = import.meta.env.VITE_API_BASE_URL ?? "";

export class ApiError extends Error {
  status: number;
  body: unknown;
  constructor(message: string, status: number, body: unknown) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

export async function apiFetch<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      "content-type": "application/json",
      "x-device-id": getDeviceId(),
      ...(init.headers ?? {}),
    },
  });

  const body = (await res.json().catch(() => null)) as unknown;

  if (!res.ok) {
    const message =
      body &&
      typeof body === "object" &&
      "error" in body &&
      typeof (body as { error: unknown }).error === "string"
        ? (body as { error: string }).error
        : `HTTP ${res.status}`;
    throw new ApiError(message, res.status, body);
  }

  return body as T;
}
